export const groupsOfModifiers = {
  Next: 'Next',
  Previous : 'Previous'
}